export enum FooterContentTypeEnum {
    FOOTER_CONTENT_1 = 'FOOTER_CONTENT_1',
    FOOTER_CONTENT_2 = 'FOOTER_CONTENT_2',
}
